import { httpClient } from '@/services/http/httpClient'

type GetUsersPortfolioParams = {
  portfolioId: string
}

export type GetUsersPortfolioResponse = {
  id: string
  name: string
  email: string
  image: string
  type: string
  status: string
}
export const getUsersPortfolio = async (params: GetUsersPortfolioParams) => {
  const { data } = await httpClient.get<GetUsersPortfolioResponse[]>(
    `/projects/portfolios/${params.portfolioId}/users`,
  )

  return data
}
